import type { ChannelSpecificOptionListsType } from "./types";

export const channelSpecificOptionLists: ChannelSpecificOptionListsType = {
  api: {
    allowedOptions: [],
    dispatchPropertyAllowedInCampaignProperties: true,
    alwaysUseLiquidSettingsFromContext: false,
  },
  banner: {
    allowedOptions: [
      "API_TRIGGER_EVENT_PROPERTIES",
      "CATALOG_ITEMS",
      "CONNECTED_CONTENT",
      "PRODUCT_RECOMMENDATION",
      "B2B",
      "BASIC_ATTRIBUTES",
      "CUSTOM_ATTRIBUTES",
      "NESTED_CUSTOM_ATTRIBUTES",
      "MOST_RECENT_DEVICE_ATTRIBUTES",
      "CONTENT_BLOCKS",
      "PREFERENCE_CENTER",
      "LANDING_PAGE",
      "TRANSLATION",
    ],
    dispatchPropertyAllowedInCampaignProperties: false,
    alwaysUseLiquidSettingsFromContext: true,
  },
  contentBlock: {
    allowedOptions: [
      "MESSAGE_EXTRAS",
      "CATALOG_ITEMS",
      "PRODUCT_RECOMMENDATION",
      "EMAIL_PROPERTIES",
      "TARGETED_DEVICE_ATTRIBUTES",
      "CONNECTED_CONTENT",
      "VOUCHER",
      "B2B",
      "TRANSLATION",
    ],
    dispatchPropertyAllowedInCampaignProperties: true,
    alwaysUseLiquidSettingsFromContext: false,
  },
  contentCard: {
    allowedOptions: [
      "MESSAGE_EXTRAS",
      "CATALOG_ITEMS",
      "PRODUCT_RECOMMENDATION",
      "CONNECTED_CONTENT",
      "VOUCHER",
      "B2B",
    ],
    dispatchPropertyAllowedInCampaignProperties: false,
    alwaysUseLiquidSettingsFromContext: false,
  },
  email: {
    allowedOptions: [
      "MESSAGE_EXTRAS",
      "EMAIL_PROPERTIES",
      "CATALOG_ITEMS",
      "PRODUCT_RECOMMENDATION",
      "CONNECTED_CONTENT",
      "VOUCHER",
      "TRANSLATION",
      "B2B",
    ],
    dispatchPropertyAllowedInCampaignProperties: true,
    alwaysUseLiquidSettingsFromContext: false,
  },
  optInPage: {
    allowedOptions: [],
    dispatchPropertyAllowedInCampaignProperties: false,
    alwaysUseLiquidSettingsFromContext: false,
  },
  unsubscribePage: {
    allowedOptions: [],
    dispatchPropertyAllowedInCampaignProperties: false,
    alwaysUseLiquidSettingsFromContext: false,
  },
  iam: {
    allowedOptions: [
      "MESSAGE_EXTRAS",
      "TARGETED_DEVICE_ATTRIBUTES",
      "CATALOG_ITEMS",
      "PRODUCT_RECOMMENDATION",
      "CONNECTED_CONTENT",
      "VOUCHER",
      "TRANSLATION",
      "B2B",
    ],
    dispatchPropertyAllowedInCampaignProperties: false,
    alwaysUseLiquidSettingsFromContext: true,
  },
  kakao: {
    allowedOptions: [
      "MESSAGE_EXTRAS",
      "CATALOG_ITEMS",
      "PRODUCT_RECOMMENDATION",
      "CONNECTED_CONTENT",
      "VOUCHER",
      "B2B",
    ],
    dispatchPropertyAllowedInCampaignProperties: true,
    alwaysUseLiquidSettingsFromContext: false,
  },
  landingPage: {
    allowedOptions: ["CATALOG_ITEMS", "PRODUCT_RECOMMENDATION"],
    dispatchPropertyAllowedInCampaignProperties: false,
    alwaysUseLiquidSettingsFromContext: true,
  },
  preferenceCenter: {
    allowedOptions: [
      "CATALOG_ITEMS",
      "PRODUCT_RECOMMENDATION",
      "CONNECTED_CONTENT",
      "VOUCHER",
      "EMAIL_PROPERTIES",
      "B2B",
    ],
    dispatchPropertyAllowedInCampaignProperties: true,
    alwaysUseLiquidSettingsFromContext: true,
  },
  push: {
    allowedOptions: [
      "MESSAGE_EXTRAS",
      "TARGETED_DEVICE_ATTRIBUTES",
      "CATALOG_ITEMS",
      "PRODUCT_RECOMMENDATION",
      "CONNECTED_CONTENT",
      "VOUCHER",
      "TRANSLATION",
      "B2B",
    ],
    dispatchPropertyAllowedInCampaignProperties: true,
    alwaysUseLiquidSettingsFromContext: false,
  },
  sms: {
    allowedOptions: [
      "MESSAGE_EXTRAS",
      "CATALOG_ITEMS",
      "PRODUCT_RECOMMENDATION",
      "CONNECTED_CONTENT",
      "VOUCHER",
      "B2B",
    ],
    dispatchPropertyAllowedInCampaignProperties: true,
    alwaysUseLiquidSettingsFromContext: false,
  },
  transactionalEmail: {
    allowedOptions: ["MESSAGE_EXTRAS", "EMAIL_PROPERTIES"],
    dispatchPropertyAllowedInCampaignProperties: true,
    alwaysUseLiquidSettingsFromContext: false,
  },
  webhook: {
    allowedOptions: [
      "MESSAGE_EXTRAS",
      "CATALOG_ITEMS",
      "PRODUCT_RECOMMENDATION",
      "CONNECTED_CONTENT",
      "VOUCHER",
      "TRANSLATION",
      "B2B",
    ],
    dispatchPropertyAllowedInCampaignProperties: true,
    alwaysUseLiquidSettingsFromContext: false,
  },
  whatsApp: {
    allowedOptions: [
      "CONNECTED_CONTENT",
      "VOUCHER",
      "CATALOG_ITEMS",
      "PRODUCT_RECOMMENDATION",
      "MESSAGE_EXTRAS",
      "B2B",
    ],
    dispatchPropertyAllowedInCampaignProperties: true,
    alwaysUseLiquidSettingsFromContext: false,
  },
  line: {
    allowedOptions: [
      "MESSAGE_EXTRAS",
      "CATALOG_ITEMS",
      "PRODUCT_RECOMMENDATION",
      "CONNECTED_CONTENT",
      "VOUCHER",
      "B2B",
    ],
    dispatchPropertyAllowedInCampaignProperties: true,
    alwaysUseLiquidSettingsFromContext: false,
  },
  anything: {
    allowedOptions: [
      "MESSAGE_EXTRAS",
      "CATALOG_ITEMS",
      "PRODUCT_RECOMMENDATION",
      "EMAIL_PROPERTIES",
      "TARGETED_DEVICE_ATTRIBUTES",
      "CONNECTED_CONTENT",
      "VOUCHER",
      "B2B",
    ],
    dispatchPropertyAllowedInCampaignProperties: true,
    alwaysUseLiquidSettingsFromContext: false,
  },
  none: {
    allowedOptions: [],
    dispatchPropertyAllowedInCampaignProperties: false,
    alwaysUseLiquidSettingsFromContext: false,
  },
};
